"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _SvgIcon = require("../SvgIcon");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
} /**
  * This file was generated by the build:icons script
  * See Notion for details on how to add icons
  */
const ChatIcon = props => /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, _extends({}, props, {
  viewBox: "0 0 24 24"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.946 20.016a7.113 7.113 0 0 1-.096.039c-.072.027-.047.623 0 .69a6.58 6.58 0 0 0 1.88-.038 7.064 7.064 0 0 0 1.705-.508c.657-.29 1.222-.654 1.697-.96.577-.372 1.021-.658 1.333-.618.475.061.686.088.897.1.17.01.342.01.655.01 4.98 0 9.018-3.297 9.018-7.365S16.997 4 12.017 4 3 7.298 3 11.366c0 2.545 1.307 4.529 3.71 5.852.128.07.025.695-.447 1.296-.12.153-.264.305-.435.445-.585.482-1.41.867-1.882 1.057Zm4.802-2.892c.1-.056.2-.11.301-.16.273-.135.906-.425 1.67-.327.458.059.602.077.725.086.107.007.202.009.573.009 4.273 0 7.018-2.762 7.018-5.366C19.035 8.762 16.29 6 12.017 6S5 8.762 5 11.366c0 1.708.81 3.074 2.675 4.1.77.425.975 1.146 1.028 1.382.022.097.036.19.045.276Z"
}));
exports.ChatIcon = ChatIcon;